import { validateBusinessPayload } from './auditSafety';
import { validateUpload } from './uploadValidation';

export const validateRequestBody = async (body, method, pathname) => {
  if (!/^(POST|PUT|PATCH|DELETE)$/i.test(method || '') || body == null) return;
  try {
    if (body instanceof FormData) {
      const files = [...body.values()].filter(value => value instanceof Blob);
      if (files.length > 1) throw new Error('Upload one file at a time.');
      for (const [key, value] of body.entries()) {
        if (value instanceof Blob) {
          await validateUpload(value, { imagesOnly: /\/master\/dep\/[^/]+\/upload\/?$/.test(pathname) });
        } else validateBusinessPayload(value, key);
      }
      return;
    }
    if (body instanceof URLSearchParams) {
      for (const [key, value] of body.entries()) validateBusinessPayload(value, key);
      return;
    }
    let payload = body;
    if (typeof body === 'string') {
      try { payload = JSON.parse(body); } catch { throw new Error('Unable to prepare the form. Please check your entries.'); }
    }
    validateBusinessPayload(payload);
  } catch (error) {
    window.dispatchEvent(new CustomEvent('rcs-validation-error', { detail: error.message }));
    throw error;
  }
};
